import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FrontHeader from '../components/common/FrontHeader';
import FrontFooter from '../components/common/FrontFooter';
import heroVideo from '../assets/hero-video.mp4';
import backImage from '../assets/back-image12.jpeg';
import backgroundImage3 from '../assets/image-3.jpeg';
import "../styles/LandingPage.css";

function LandingPageNew() {
  const navigate = useNavigate();
  const [howItWorksTab, setHowItWorksTab] = useState('owner');

  useEffect(() => {
    const token = localStorage.getItem('marilink_token');
    const user = JSON.parse(localStorage.getItem('marilink_user') || 'null');
    if (token && user) navigate(`/${user.role}/dashboard`);
  }, [navigate]);

  // Counter animation for stats
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const statItems = entry.target.querySelectorAll('.lp-stat-item');
          statItems.forEach(statItem => {
            const counter = statItem.querySelector('.lp-stat-number');
            if (!counter) return;
            const target = parseInt(counter.getAttribute('data-target') || '0');
            let current = 0;
            const increment = target / 60;
            const updateCounter = () => {
              current += increment;
              if (current < target) {
                counter.innerText = Math.ceil(current);
                requestAnimationFrame(updateCounter);
              } else {
                counter.innerText = target;
              }
            };
            updateCounter();
          });
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    const statsSection = document.querySelector('.lp-stats');
    if (statsSection) observer.observe(statsSection);
    return () => observer.disconnect();
  }, []);

  // Scroll reveal animation
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) entry.target.classList.add('lp-visible');
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.lp-animate').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, [howItWorksTab]);

  const openBetaRegistration = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSdCIVosOGBcN_c1kjm17h_dHgKd3lOZGv-13ZmAeK7vyi9z2A/viewform', '_blank');
  };

  const handleServicesClick = () => navigate('/services');
  const handlePostRFQ = () => {
    const token = localStorage.getItem('marilink_token');
    if (token) navigate('/owner/post-job');
    else navigate('/login', { state: { from: '/owner/post-job' } });
  };

  const popularTags = [
    'Core Services', 'Port Agency Services', 'Ship Chandling',
    'Bunkering Coordination', 'Spare Parts Supply', 'Marine Lubricants',
    'Technical Maintenance', 'Safety Equipment Supply', 'Class Inspection Support',
    'Hull Cleaning & Diving Services', 'Crew Change Coordination'
  ];

  return (
    <div className="lp-container" style={{ background: '#000', minHeight: '100vh' }}>
      {/* ---------- Only essential styles, no universal reset ---------- */}
      <style dangerouslySetInnerHTML={{ __html: `
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap');

        .lp-container {
          font-family: 'Poppins', sans-serif;
          color: #fff;
        }

        .lp-hero {
          position: relative;
          min-height: 100vh;
          display: flex;
          align-items: center;
          overflow: hidden;
        }
        .lp-hero-video-container {
          position: absolute;
          top: 0; left: 0;
          width: 100%; height: 100%;
          z-index: 0;
        }
        .lp-hero-video {
          width: 100%; height: 100%;
          object-fit: cover;
        }
        .lp-hero-overlay {
          position: absolute;
          top: 0; left: 0;
          width: 100%; height: 100%;
          background: linear-gradient(135deg, rgba(0,0,0,0.6), rgba(0,0,0,0.7));
          z-index: 1;
        }
        .lp-hero-container {
          max-width: 1300px;
          margin: 0 auto;
          padding: 0 2rem;
          position: relative;
          z-index: 2;
          width: 100%;
        }
        .lp-hero-content {
          max-width: 700px;
        }
        @media (max-width: 768px) {
          .lp-hero-content { text-align: center; max-width: 100%; }
        }
        .lp-hero-title {
          font-size: 3.5rem;
          font-weight: 800;
          margin-bottom: 1.5rem;
          color: white;
        }
        @media (max-width: 768px) {
          .lp-hero-title { font-size: 2.2rem; }
        }
        .lp-highlight { color: #18cb96; }
        .lp-hero-subtitle {
          font-size: 1.2rem;
          line-height: 1.6;
          margin-bottom: 2rem;
          color: rgba(255,255,255,0.9);
        }
        .lp-search-bar {
          display: flex;
          background: rgba(0,0,0,0.6);
          backdrop-filter: blur(10px);
          border-radius: 60px;
          padding: 6px;
          border: 1px solid rgba(255,255,255,0.2);
          margin-bottom: 2rem;
        }
        @media (max-width: 768px) {
          .lp-search-bar { flex-direction: column; border-radius: 24px; padding: 0.8rem; gap: 0.8rem; }
          .lp-search-input { width: 100%; padding: 14px 20px; }
          .lp-search-btn { width: 100%; padding: 14px 24px; }
        }
        .lp-search-input {
          flex: 1;
          border: none; outline: none;
          padding: 15px 24px;
          font-size: 1rem;
          border-radius: 50px;
          background: transparent;
          color: white;
        }
        .lp-search-input::placeholder { color: rgba(255,255,255,0.6); }
        .lp-search-btn {
          background: #18cb96;
          color: #000;
          border: none;
          padding: 0 32px;
          border-radius: 50px;
          font-weight: 700;
          cursor: pointer;
        }
        .lp-trust-badges {
          display: flex;
          align-items: center;
          gap: 1rem;
          flex-wrap: wrap;
        }
        .lp-trust-badges h3 {
          font-size: 0.9rem;
          font-weight: 600;
          color: #18cb96;
        }
        .lp-brands {
          display: flex;
          gap: 0.75rem;
          flex-wrap: wrap;
        }
        .lp-brands span {
          background: rgba(24,203,150,0.1);
          padding: 5px 12px;
          border-radius: 20px;
          font-size: 0.75rem;
          cursor: pointer;
          border: 1px solid rgba(24,203,150,0.2);
          transition: all 0.3s;
        }
        .lp-brands span:hover {
          background: rgba(24,203,150,0.2);
          border-color: #18cb96;
          transform: translateY(-2px);
        }

        /* Beta Banner */
        .lp-beta-banner {
          padding: 0.8rem 0;
          background: linear-gradient(135deg, rgba(24,203,150,0.15), rgba(24,203,150,0.05));
          border-bottom: 1px solid rgba(24,203,150,0.3);
          border-top: 1px solid rgba(24,203,150,0.3);
        }
        .lp-beta-banner-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 1rem;
          flex-wrap: wrap;
          max-width: 1300px;
          margin: 0 auto;
          padding: 0 2rem;
        }
        .lp-beta-banner-text {
          display: flex;
          align-items: center;
          gap: 0.8rem;
          font-size: 0.9rem;
        }
        .lp-beta-banner-text i { font-size: 1.2rem; color: #18cb96; }
        .lp-beta-banner-btn {
          background: #18cb96;
          border: none;
          color: #000;
          padding: 8px 20px;
          border-radius: 50px;
          font-weight: 600;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          transition: all 0.3s;
        }
        .lp-beta-banner-btn:hover { background: #0f9e72; transform: translateY(-2px); }

        /* Sections */
        .lp-container-inner {
          max-width: 1300px;
          margin: 0 auto;
          padding: 0 2rem;
        }
        @media (max-width: 768px) {
          .lp-container-inner { padding: 0 1.25rem; }
        }
        .lp-section {
          padding: 5rem 0;
        }
        @media (max-width: 768px) {
          .lp-section { padding: 3rem 0; }
        }
        .lp-section-header {
          text-align: center;
          margin-bottom: 3rem;
        }
        .lp-section-tag {
          display: block;
          font-size: 0.85rem;
          font-weight: 600;
          color: #18cb96;
          text-transform: uppercase;
          letter-spacing: 3px;
          margin-bottom: 0.5rem;
        }
        .lp-section-header h2 {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 1rem;
          color: white;
        }
        @media (max-width: 768px) {
          .lp-section-header h2 { font-size: 1.8rem; }
        }
        .lp-section-subtitle {
          font-size: 1rem;
          color: rgba(255,255,255,0.6);
          max-width: 800px;
          margin: 0 auto;
        }

        /* Features Grid */
        .lp-features-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 1.5rem;
        }
        @media (max-width: 1024px) {
          .lp-features-grid { grid-template-columns: repeat(2, 1fr); }
        }
        @media (max-width: 640px) {
          .lp-features-grid { grid-template-columns: 1fr; }
        }
        .lp-feature-card {
          background: linear-gradient(135deg, rgba(255,255,255,0.05), rgba(255,255,255,0.02));
          border: 1px solid rgba(255,255,255,0.1);
          padding: 2rem;
          border-radius: 20px;
          text-align: center;
          transition: all 0.4s;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        .lp-feature-card::before, .lp-feature-card::after {
          content: '';
          position: absolute;
          width: 100%;
          height: 2px;
          background: linear-gradient(90deg, transparent, #18cb96, transparent);
          transition: all 0.6s;
        }
        .lp-feature-card::before { top: 0; left: -100%; }
        .lp-feature-card::after { bottom: 0; right: -100%; background: linear-gradient(270deg, transparent, #18cb96, transparent); }
        .lp-feature-card:hover::before { left: 0; }
        .lp-feature-card:hover::after { right: 0; }
        .lp-feature-card:hover {
          transform: translateY(-8px);
          border-color: transparent;
          box-shadow: 0 0 20px rgba(24,203,150,0.2);
        }
        .lp-feature-icon {
          width: 70px; height: 70px;
          background: rgba(24,203,150,0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.2rem;
          transition: transform 0.3s;
        }
        .lp-feature-card:hover .lp-feature-icon { transform: scale(1.1); }
        .lp-feature-icon i { font-size: 2rem; color: #18cb96; }
        .lp-feature-card h3 {
          font-size: 1.2rem;
          font-weight: 600;
          margin-bottom: 0.8rem;
          color: white;
        }
        .lp-feature-card p {
          color: rgba(255,255,255,0.6);
          font-size: 0.9rem;
        }

        /* How It Works */
        .lp-how-it-works {
          position: relative;
          overflow: hidden;
        }
        .lp-how-it-works-bg {
          position: absolute;
          top: 0; left: 0;
          width: 100%; height: 100%;
          background-size: cover;
          background-position: center;
          opacity: 0.12;
          z-index: 0;
          pointer-events: none;
        }
        .lp-how-it-works .lp-container-inner {
          position: relative;
          z-index: 1;
        }
        .lp-how-it-works-tabs {
          display: flex;
          justify-content: center;
          gap: 1rem;
          margin-bottom: 3rem;
          flex-wrap: wrap;
        }
        .lp-tab-btn {
          background: rgba(255,255,255,0.05);
          border: 1px solid rgba(24,203,150,0.3);
          padding: 12px 28px;
          border-radius: 50px;
          font-size: 1rem;
          font-weight: 600;
          color: #fff;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          transition: all 0.3s;
        }
        .lp-tab-btn.lp-active {
          background: #18cb96;
          color: #000;
          border-color: #18cb96;
        }
        .lp-steps-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 0.5rem;
          margin-top: 2rem;
          flex-wrap: wrap;
        }
        @media (max-width: 992px) {
          .lp-steps-container { flex-direction: column; align-items: center; gap: 1rem; }
        }
        .lp-step-box {
          flex: 1;
          min-width: 220px;
          max-width: 280px;
          text-align: center;
          background: linear-gradient(135deg, rgba(255,255,255,0.08), rgba(255,255,255,0.03));
          border: 1px solid rgba(255,255,255,0.1);
          border-radius: 20px;
          padding: 2rem 1rem;
          transition: all 0.4s;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        @media (max-width: 992px) {
          .lp-step-box { min-width: 280px; max-width: 350px; }
        }
        .lp-step-box::before, .lp-step-box::after {
          content: '';
          position: absolute;
          width: 100%;
          height: 2px;
          background: linear-gradient(90deg, transparent, #18cb96, transparent);
          transition: all 0.6s;
        }
        .lp-step-box::before { top: 0; left: -100%; }
        .lp-step-box::after { bottom: 0; right: -100%; background: linear-gradient(270deg, transparent, #18cb96, transparent); }
        .lp-step-box:hover::before { left: 0; }
        .lp-step-box:hover::after { right: 0; }
        .lp-step-box:hover {
          transform: translateY(-5px);
          border-color: transparent;
          box-shadow: 0 0 20px rgba(24,203,150,0.15);
        }
        .lp-step-number {
          display: inline-block;
          font-size: 0.8rem;
          font-weight: 700;
          color: #18cb96;
          background: rgba(24,203,150,0.15);
          padding: 4px 12px;
          border-radius: 20px;
          margin-bottom: 1rem;
        }
        .lp-step-icon {
          width: 80px; height: 80px;
          background: rgba(24,203,150,0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1rem;
          transition: transform 0.3s;
        }
        .lp-step-box:hover .lp-step-icon { transform: scale(1.1); }
        .lp-step-icon i { font-size: 2rem; color: #18cb96; }
        .lp-step-box h3 {
          font-size: 1.2rem;
          font-weight: 600;
          margin-bottom: 0.8rem;
          color: white;
        }
        .lp-step-box p {
          font-size: 0.85rem;
          color: rgba(255,255,255,0.6);
        }
        .lp-step-arrow i {
          font-size: 1.5rem;
          color: #18cb96;
        }
        @media (max-width: 992px) {
          .lp-step-arrow { transform: rotate(90deg); margin: 0.5rem 0; }
        }

        /* Stats */
        .lp-stats { padding: 4rem 0; }
        .lp-stats-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 1.5rem;
          text-align: center;
        }
        @media (max-width: 768px) {
          .lp-stats-grid { grid-template-columns: repeat(2, 1fr); }
        }
        @media (max-width: 480px) {
          .lp-stats-grid { grid-template-columns: 1fr; }
        }
        .lp-stat-item {
          background: linear-gradient(135deg, rgba(255,255,255,0.05), rgba(255,255,255,0.02));
          border-radius: 20px;
          padding: 2rem;
          border: 1px solid rgba(255,255,255,0.1);
          transition: all 0.4s;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        .lp-stat-item::before, .lp-stat-item::after {
          content: '';
          position: absolute;
          width: 100%;
          height: 2px;
          background: linear-gradient(90deg, transparent, #18cb96, transparent);
          transition: all 0.6s;
        }
        .lp-stat-item::before { top: 0; left: -100%; }
        .lp-stat-item::after { bottom: 0; right: -100%; background: linear-gradient(270deg, transparent, #18cb96, transparent); }
        .lp-stat-item:hover::before { left: 0; }
        .lp-stat-item:hover::after { right: 0; }
        .lp-stat-item:hover {
          transform: translateY(-5px);
          border-color: transparent;
          box-shadow: 0 0 20px rgba(24,203,150,0.1);
        }
        .lp-stat-number-wrapper {
          display: flex;
          align-items: baseline;
          justify-content: center;
          gap: 0.1rem;
          margin-bottom: 0.5rem;
        }
        .lp-stat-number { font-size: 2.8rem; font-weight: 800; color: #18cb96; }
        .lp-stat-suffix { font-size: 2rem; font-weight: 700; color: #18cb96; }
        .lp-stat-label { font-size: 0.9rem; color: rgba(255,255,255,0.7); }

        /* Categories */
        .lp-category-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1.5rem;
        }
        @media (max-width: 992px) {
          .lp-category-grid { grid-template-columns: repeat(2, 1fr); }
        }
        @media (max-width: 576px) {
          .lp-category-grid { grid-template-columns: 1fr; }
        }
        .lp-category-card {
          background: linear-gradient(135deg, rgba(255,255,255,0.05), rgba(255,255,255,0.02));
          border: 1px solid rgba(255,255,255,0.1);
          padding: 1.5rem;
          border-radius: 20px;
          transition: all 0.4s;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        .lp-category-card::before, .lp-category-card::after {
          content: '';
          position: absolute;
          width: 100%;
          height: 2px;
          background: linear-gradient(90deg, transparent, #18cb96, transparent);
          transition: all 0.6s;
        }
        .lp-category-card::before { top: 0; left: -100%; }
        .lp-category-card::after { bottom: 0; right: -100%; background: linear-gradient(270deg, transparent, #18cb96, transparent); }
        .lp-category-card:hover::before { left: 0; }
        .lp-category-card:hover::after { right: 0; }
        .lp-category-card:hover {
          transform: translateY(-5px);
          border-color: transparent;
          box-shadow: 0 0 20px rgba(24,203,150,0.1);
        }
        .lp-category-icon-wrapper {
          width: 55px; height: 55px;
          background: rgba(24,203,150,0.1);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 1rem;
          transition: transform 0.3s;
        }
        .lp-category-card:hover .lp-category-icon-wrapper { transform: scale(1.1); }
        .lp-category-icon { font-size: 1.5rem; color: #18cb96; }
        .lp-category-card h3 { font-size: 1rem; font-weight: 600; margin-bottom: 0.5rem; color: white; }
        .lp-category-card p { font-size: 0.8rem; color: rgba(255,255,255,0.5); margin-bottom: 0.8rem; }
        .lp-category-count {
          display: inline-block;
          font-size: 0.7rem;
          color: #18cb96;
          background: rgba(24,203,150,0.1);
          padding: 3px 10px;
          border-radius: 20px;
        }

        /* Testimonials */
        .lp-testimonials-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1.5rem;
        }
        @media (max-width: 1024px) { .lp-testimonials-grid { grid-template-columns: repeat(2, 1fr); } }
        @media (max-width: 640px) { .lp-testimonials-grid { grid-template-columns: 1fr; } }
        .lp-testimonial-card {
          background: linear-gradient(135deg, rgba(255,255,255,0.05), rgba(255,255,255,0.02));
          border: 1px solid rgba(255,255,255,0.1);
          padding: 2rem;
          border-radius: 20px;
          transition: all 0.4s;
          position: relative;
          overflow: hidden;
        }
        .lp-testimonial-card::before, .lp-testimonial-card::after {
          content: '';
          position: absolute;
          width: 100%;
          height: 2px;
          background: linear-gradient(90deg, transparent, #18cb96, transparent);
          transition: all 0.6s;
        }
        .lp-testimonial-card::before { top: 0; left: -100%; }
        .lp-testimonial-card::after { bottom: 0; right: -100%; background: linear-gradient(270deg, transparent, #18cb96, transparent); }
        .lp-testimonial-card:hover::before { left: 0; }
        .lp-testimonial-card:hover::after { right: 0; }
        .lp-testimonial-card:hover {
          transform: translateY(-5px);
          border-color: transparent;
          box-shadow: 0 0 20px rgba(24,203,150,0.1);
        }
        .lp-testimonial-quote i { font-size: 1.5rem; color: #18cb96; opacity: 0.5; margin-bottom: 1rem; }
        .lp-testimonial-card p { font-size: 0.9rem; line-height: 1.6; color: rgba(255,255,255,0.8); margin-bottom: 1.5rem; }
        .lp-testimonial-author { display: flex; align-items: center; gap: 0.8rem; }
        .lp-author-image i { font-size: 2rem; color: rgba(24,203,150,0.5); }
        .lp-author-info h4 { font-size: 0.9rem; font-weight: 600; margin-bottom: 0.2rem; color: white; }
        .lp-author-info span { font-size: 0.75rem; color: rgba(255,255,255,0.5); }

        /* Newsletter */
        .lp-newsletter-content {
          background: linear-gradient(135deg, rgba(24,203,150,0.1), rgba(24,203,150,0.05));
          border: 1px solid rgba(24,203,150,0.2);
          border-radius: 30px;
          padding: 3rem;
          text-align: center;
        }
        .lp-newsletter-text h3 { font-size: 1.5rem; font-weight: 600; color: white; margin-bottom: 0.5rem; }
        .lp-newsletter-text p { color: rgba(255,255,255,0.6); margin-bottom: 1.5rem; }
        .lp-newsletter-form { display: flex; gap: 0.8rem; max-width: 500px; margin: 0 auto; }
        @media (max-width: 576px) { .lp-newsletter-form { flex-direction: column; } }
        .lp-newsletter-form input {
          flex: 1;
          padding: 12px 20px;
          border: 1px solid rgba(255,255,255,0.2);
          border-radius: 50px;
          background: rgba(255,255,255,0.05);
          color: white;
          outline: none;
        }
        .lp-newsletter-form button {
          padding: 12px 28px;
          background: #18cb96;
          border: none;
          border-radius: 50px;
          color: #000;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s;
        }
        .lp-newsletter-form button:hover { background: #0f9e72; transform: translateY(-2px); }

        /* Global Coverage */
        .lp-global-coverage { background: #000; }
        .lp-coverage-content {
          display: flex;
          align-items: center;
          gap: 3rem;
          background: linear-gradient(135deg, rgba(24,203,150,0.08), rgba(24,203,150,0.02));
          border: 1px solid rgba(24,203,150,0.2);
          border-radius: 30px;
          padding: 3rem;
          transition: all 0.4s;
        }
        .lp-coverage-content:hover {
          border-color: #18cb96;
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0,0,0,0.3);
        }
        @media (max-width: 992px) { .lp-coverage-content { flex-direction: column; text-align: center; padding: 2rem; } }
        .lp-coverage-text { flex: 1; }
        .lp-coverage-text h2 { font-size: 2rem; font-weight: 700; margin-bottom: 1rem; color: white; }
        .lp-coverage-text p { color: rgba(255,255,255,0.7); margin-bottom: 1.5rem; }
        .lp-coverage-stats { display: flex; gap: 1rem; margin-bottom: 1.5rem; flex-wrap: wrap; }
        @media (max-width: 992px) { .lp-coverage-stats { justify-content: center; } }
        .lp-coverage-stat-card {
          background: rgba(0,0,0,0.4);
          border: 1px solid rgba(24,203,150,0.3);
          border-radius: 16px;
          padding: 0.8rem 1.2rem;
          display: flex;
          align-items: center;
          gap: 0.8rem;
          cursor: pointer;
          transition: all 0.3s;
        }
        .lp-coverage-stat-card:hover { border-color: #18cb96; transform: translateY(-3px); background: rgba(24,203,150,0.1); }
        .lp-coverage-stat-card i { font-size: 1.5rem; color: #18cb96; }
        .lp-stat-info h4 { font-size: 1.2rem; font-weight: 700; color: white; }
        .lp-stat-info span { font-size: 0.7rem; color: rgba(255,255,255,0.6); }
        .lp-coverage-btn {
          background: #18cb96;
          color: #000;
          border: none;
          padding: 12px 28px;
          border-radius: 50px;
          font-weight: 600;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          transition: all 0.3s;
        }
        .lp-coverage-btn:hover { background: #0f9e72; transform: translateY(-2px); }
        .lp-coverage-image i {
          font-size: 8rem;
          color: rgba(24,203,150,0.2);
          animation: lp-float 3s ease-in-out infinite;
        }
        @keyframes lp-float { 0%,100%{transform:translateY(0);} 50%{transform:translateY(-15px);} }
        @media (max-width: 768px) { .lp-coverage-image i { font-size: 4.5rem; } }

        /* Partner Benefits */
        .lp-partner-benefits { position: relative; }
        .lp-partner-benefits-bg {
          position: absolute; top:0; left:0; width:100%; height:100%;
          background-size: cover; background-position: center; opacity:0.1; z-index:0;
        }
        .lp-partner-benefits .lp-container-inner { position: relative; z-index: 2; }
        .lp-benefits-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 1.5rem;
        }
        @media (max-width: 1024px) { .lp-benefits-grid { grid-template-columns: repeat(2, 1fr); } }
        @media (max-width: 640px) { .lp-benefits-grid { grid-template-columns: 1fr; } }
        .lp-benefit-card {
          background: rgba(255,255,255,0.05);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(24,203,150,0.3);
          padding: 2rem;
          border-radius: 20px;
          text-align: center;
          transition: all 0.4s;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        .lp-benefit-card::before, .lp-benefit-card::after {
          content: '';
          position: absolute;
          width: 100%;
          height: 2px;
          background: linear-gradient(90deg, transparent, #18cb96, transparent);
          transition: all 0.6s;
        }
        .lp-benefit-card::before { top: 0; left: -100%; }
        .lp-benefit-card::after { bottom: 0; right: -100%; background: linear-gradient(270deg, transparent, #18cb96, transparent); }
        .lp-benefit-card:hover::before { left: 0; }
        .lp-benefit-card:hover::after { right: 0; }
        .lp-benefit-card:hover {
          transform: translateY(-8px);
          border-color: transparent;
          background: rgba(24,203,150,0.1);
          box-shadow: 0 0 20px rgba(24,203,150,0.15);
        }
        .lp-benefit-icon {
          width: 70px; height: 70px;
          background: rgba(24,203,150,0.15);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1rem;
          transition: transform 0.3s;
        }
        .lp-benefit-card:hover .lp-benefit-icon { transform: scale(1.1); }
        .lp-benefit-icon i { font-size: 2rem; color: #18cb96; }
        .lp-benefit-card h3 { font-size: 1.2rem; font-weight: 600; margin-bottom: 0.8rem; color: white; }
        .lp-benefit-card p { color: rgba(255,255,255,0.7); font-size: 0.85rem; }

        /* Animation */
        .lp-animate {
          opacity: 0;
          transform: translateY(30px);
          transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .lp-animate.lp-visible { opacity: 1; transform: translateY(0); }
      `}} />

      <FrontHeader />

      {/* Hero Section */}
      <header className="lp-hero">
        <div className="lp-hero-video-container">
          <video autoPlay loop muted playsInline className="lp-hero-video">
            <source src={heroVideo} type="video/mp4" />
          </video>
          <div className="lp-hero-overlay"></div>
        </div>
        <div className="lp-hero-container">
          <div className="lp-hero-content">
            <h1 className="lp-hero-title">
              Maritime Services <br /> <span className="lp-highlight">Let's hire experts</span>
            </h1>
            <p className="lp-hero-subtitle">
              Connect directly with verified providers. Secure payments by escrow. No middlemen.
            </p>
            <div className="lp-search-bar">
              <input type="text" placeholder="What service do you need? (e.g., GMDSS repair, AIS calibration)" className="lp-search-input" />
              <button className="lp-search-btn" onClick={handlePostRFQ}>Post RFQ</button>
            </div>
            <div className="lp-trust-badges">
              <h3>Popular :</h3>
              <div className="lp-brands">
                {popularTags.map((tag, index) => (
                  <span key={index} onClick={handleServicesClick}>{tag}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Beta Banner */}
      <div className="lp-beta-banner">
        <div className="lp-beta-banner-content">
          <div className="lp-beta-banner-text">
            <i className="fas fa-rocket"></i>
            <span>Beta Launch — 100% FREE • No commission • No fee </span>
          </div>
          <button className="lp-beta-banner-btn" onClick={openBetaRegistration}>
            Register for Beta Launch <i className="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>

      {/* Features Section */}
      <section className="lp-section">
        <div className="lp-container-inner">
          <div className="lp-section-header">
            <span className="lp-section-tag">Why Choose Us</span>
            <h2>Built for Maritime Excellence</h2>
            <p className="lp-section-subtitle">Experience a smarter way to manage your vessel services</p>
          </div>
          <div className="lp-features-grid">
            <div className="lp-feature-card lp-animate" onClick={() => navigate('/')}>
              <div className="lp-feature-icon"><i className="fas fa-shield-alt"></i></div>
              <h3>Secure Escrow</h3>
              <p>Funds are protected until work completion. 100% safe transactions.</p>
            </div>
            <div className="lp-feature-card lp-animate" onClick={() => navigate('/')}>
              <div className="lp-feature-icon"><i className="fas fa-check-double"></i></div>
              <h3>Verified Providers</h3>
              <p>All service providers are Class-approved and thoroughly vetted.</p>
            </div>
            <div className="lp-feature-card lp-animate" onClick={() => navigate('/')}>
              <div className="lp-feature-icon"><i className="fas fa-chart-line"></i></div>
              <h3>Transparent Pricing</h3>
              <p>Direct quotes from providers. No hidden fees or middlemen.</p>
            </div>
            <div className="lp-feature-card lp-animate" onClick={() => navigate('/')}>
              <div className="lp-feature-icon"><i className="fas fa-clock"></i></div>
              <h3>24/7 Support</h3>
              <p>Maritime experts available round the clock for assistance.</p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="lp-section lp-how-it-works">
        <div className="lp-how-it-works-bg" style={{backgroundImage: `url(${backgroundImage3})`}}></div>
        <div className="lp-container-inner">
          <div className="lp-section-header">
            <span className="lp-section-tag">Process</span>
            <h2>How It Works</h2>
            <p className="lp-section-subtitle">Simple steps to get your maritime services done efficiently</p>
          </div>
          <div className="lp-how-it-works-tabs">
            <button className={`lp-tab-btn ${howItWorksTab === 'owner' ? 'lp-active' : ''}`} onClick={() => setHowItWorksTab('owner')}>
              <i className="fas fa-ship"></i> For Ship Owners
            </button>
            <button className={`lp-tab-btn ${howItWorksTab === 'provider' ? 'lp-active' : ''}`} onClick={() => setHowItWorksTab('provider')}>
              <i className="fas fa-tools"></i> For Service Providers
            </button>
          </div>
          {howItWorksTab === 'owner' && (
            <div className="lp-steps-container">
              <div className="lp-step-box"><div className="lp-step-number">01</div><div className="lp-step-icon"><i className="fas fa-file-alt"></i></div><h3>Post RFQ</h3><p>Submit vessel details, IMO number, port location and service requirements</p></div>
              <div className="lp-step-arrow"><i className="fas fa-arrow-right"></i></div>
              <div className="lp-step-box"><div className="lp-step-number">02</div><div className="lp-step-icon"><i className="fas fa-gavel"></i></div><h3>Receive Bids</h3><p>Get quotes from verified service providers</p></div>
              <div className="lp-step-arrow"><i className="fas fa-arrow-right"></i></div>
              <div className="lp-step-box"><div className="lp-step-number">03</div><div className="lp-step-icon"><i className="fas fa-lock"></i></div><h3>Secure Escrow</h3><p>Funds locked safely until work is completed</p></div>
              <div className="lp-step-arrow"><i className="fas fa-arrow-right"></i></div>
              <div className="lp-step-box"><div className="lp-step-number">04</div><div className="lp-step-icon"><i className="fas fa-check-circle"></i></div><h3>Approve & Release</h3><p>Review work and release payment</p></div>
            </div>
          )}
          {howItWorksTab === 'provider' && (
            <div className="lp-steps-container">
              <div className="lp-step-box"><div className="lp-step-number">01</div><div className="lp-step-icon"><i className="fas fa-user-check"></i></div><h3>Register & Verify</h3><p>Create your business profile and get verified</p></div>
              <div className="lp-step-arrow"><i className="fas fa-arrow-right"></i></div>
              <div className="lp-step-box"><div className="lp-step-number">02</div><div className="lp-step-icon"><i className="fas fa-bell"></i></div><h3>Receive RFQs</h3><p>Get notified about relevant service requests</p></div>
              <div className="lp-step-arrow"><i className="fas fa-arrow-right"></i></div>
              <div className="lp-step-box"><div className="lp-step-number">03</div><div className="lp-step-icon"><i className="fas fa-chart-line"></i></div><h3>Submit Quotes</h3><p>Provide competitive bids for jobs</p></div>
              <div className="lp-step-arrow"><i className="fas fa-arrow-right"></i></div>
              <div className="lp-step-box"><div className="lp-step-number">04</div><div className="lp-step-icon"><i className="fas fa-wallet"></i></div><h3>Get Paid Securely</h3><p>Receive guaranteed payments via escrow</p></div>
            </div>
          )}
        </div>
      </section>

      {/* Stats */}
      <section className="lp-section lp-stats">
        <div className="lp-container-inner">
          <div className="lp-stats-grid">
            {[
              { target: '233', suffix: '+', label: 'Verified Providers' },
              { target: '1200', suffix: '+', label: 'Projects Completed' },
              { target: '500', suffix: '+', label: 'Ports Covered' },
              { target: '99', suffix: '%', label: 'Satisfaction Rate' }
            ].map((stat, i) => (
              <div key={i} className="lp-stat-item lp-animate">
                <div className="lp-stat-number-wrapper">
                  <span className="lp-stat-number" data-target={stat.target}>0</span>
                  <span className="lp-stat-suffix">{stat.suffix}</span>
                </div>
                <div className="lp-stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Categories */}
      <section className="lp-section">
        <div className="lp-container-inner">
          <div className="lp-section-header">
            <span className="lp-section-tag">Services</span>
            <h2>Browse by Category</h2>
            <p className="lp-section-subtitle">Find the right service provider for your vessel needs</p>
          </div>
          <div className="lp-category-grid">
            {[
              { icon: 'fa-ship', title: 'GMDSS Equipment & Repair', desc: 'Global Maritime Distress Safety System services', count: '24 providers' },
              { icon: 'fa-tools', title: 'Technical Spares & Parts', desc: 'Genuine spare parts for all vessel types', count: '32 providers' },
              { icon: 'fa-wrench', title: 'Shore-Based Maintenance', desc: 'Comprehensive SBM services worldwide', count: '21 providers' },
              { icon: 'fa-satellite-dish', title: 'AIS & VDR Services', desc: 'Automatic Identification System & Voyage Data Recorder', count: '19 providers' },
              { icon: 'fa-battery-full', title: 'Battery Replacement', desc: 'Emergency battery replacement services', count: '12 providers' },
              { icon: 'fa-globe', title: 'Satellite Communication', desc: 'VSAT, FleetBroadband & communication systems', count: '27 providers' }
            ].map((cat, i) => (
              <div key={i} className="lp-category-card lp-animate" onClick={handleServicesClick}>
                <div className="lp-category-icon-wrapper"><i className={`fas ${cat.icon} lp-category-icon`}></i></div>
                <h3>{cat.title}</h3>
                <p>{cat.desc}</p>
                <span className="lp-category-count">{cat.count}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Global Coverage */}
      <section className="lp-section lp-global-coverage">
        <div className="lp-container-inner">
          <div className="lp-coverage-content lp-animate">
            <div className="lp-coverage-text">
              <span className="lp-section-tag">Global Network</span>
              <h2>Worldwide Maritime Coverage</h2>
              <p>Access verified service providers in over 500+ ports across 100+ countries.</p>
              <div className="lp-coverage-stats">
                <div className="lp-coverage-stat-card"><i className="fas fa-anchor"></i><div className="lp-stat-info"><h4>500+</h4><span>Ports Worldwide</span></div></div>
                <div className="lp-coverage-stat-card"><i className="fas fa-ship"></i><div className="lp-stat-info"><h4>100+</h4><span>Countries</span></div></div>
                <div className="lp-coverage-stat-card"><i className="fas fa-clock"></i><div className="lp-stat-info"><h4>24/7</h4><span>Emergency Response</span></div></div>
              </div>
              <button className="lp-coverage-btn" onClick={handleServicesClick}>Explore Locations <i className="fas fa-arrow-right"></i></button>
            </div>
            <div className="lp-coverage-image"><i className="fas fa-globe-americas"></i></div>
          </div>
        </div>
      </section>

      {/* Partner Benefits */}
      <section className="lp-section lp-partner-benefits">
        <div className="lp-partner-benefits-bg" style={{backgroundImage: `url(${backImage})`}}></div>
        <div className="lp-container-inner">
          <div className="lp-section-header">
            <span className="lp-section-tag">For Partners</span>
            <h2>Grow Your Maritime Business</h2>
            <p className="lp-section-subtitle">Join our network of trusted service providers</p>
          </div>
          <div className="lp-benefits-grid">
            {[
              { icon: 'fa-chart-line', title: 'Increase Visibility', desc: 'Get discovered by ship owners worldwide' },
              { icon: 'fa-credit-card', title: 'Guaranteed Payments', desc: 'Escrow ensures you get paid on time' },
              { icon: 'fa-star', title: 'Build Reputation', desc: 'Earn ratings and reviews from clients' },
              { icon: 'fa-headset', title: 'Dedicated Support', desc: '24/7 maritime industry experts' }
            ].map((b, i) => (
              <div key={i} className="lp-benefit-card lp-animate" onClick={openBetaRegistration}>
                <div className="lp-benefit-icon"><i className={`fas ${b.icon}`}></i></div>
                <h3>{b.title}</h3>
                <p>{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="lp-section">
        <div className="lp-container-inner">
          <div className="lp-section-header">
            <span className="lp-section-tag">Testimonials</span>
            <h2>What Our Clients Say</h2>
          </div>
          <div className="lp-testimonials-grid">
            {[
              { name: 'Captain James Wilson', role: 'Fleet Manager, Maersk Line', text: 'Seazex transformed how we handle vessel maintenance.' },
              { name: 'Maria Rodriguez', role: 'Technical Superintendent, MSC', text: 'Finding verified service providers was always a challenge. Seazex solved this perfectly.' },
              { name: 'Ahmed Al Mansoori', role: 'CEO, Gulf Marine Services', text: 'As a service provider, Seazex helped us connect with genuine clients.' }
            ].map((t, i) => (
              <div key={i} className="lp-testimonial-card lp-animate">
                <div className="lp-testimonial-quote"><i className="fas fa-quote-left"></i></div>
                <p>"{t.text}"</p>
                <div className="lp-testimonial-author">
                  <div className="lp-author-image"><i className="fas fa-user-circle"></i></div>
                  <div className="lp-author-info"><h4>{t.name}</h4><span>{t.role}</span></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <section className="lp-section">
        <div className="lp-container-inner">
          <div className="lp-newsletter-content lp-animate">
            <div className="lp-newsletter-text">
              <h3>Stay Updated with Seazex News</h3>
              <p>Get the latest industry insights, service updates, and exclusive offers</p>
            </div>
            <div className="lp-newsletter-form">
              <input type="email" placeholder="Enter your email address" />
              <button onClick={openBetaRegistration}>Subscribe for Beta</button>
            </div>
          </div>
        </div>
      </section>

      <FrontFooter />
    </div>
  );
}

export default LandingPageNew;